//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { TypeHelper } from '../../../../helpers'

import { IMRTabsController } from '../tabs/tabs.controller'

import { IIMRTab, IMRTabOptions, TabItem } from './tab.interfaces'


export class IMRTabController implements ng.IComponentController, IIMRTab {

    //#region Members

    private index: number
    private name: string
    private options: IMRTabOptions
    private parentController: IMRTabsController
    private text: string
    private _isInitialized: JQueryDeferred<void>

    public isVisible: boolean
    public isActive: boolean

    //#endregion


    //#region Ctor

    public constructor(private $element: JQuery) {
        this._isInitialized = $.Deferred<void>()
    }

    //#endregion


    //#region IComponentController Implementation 

    public $onChanges(changes: { [property: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize()
        }
    }

    public $onInit(): void {
        this.registerWithParent()
    }

    //#endregion


    //#region Component

    private initialize(): void {
        this.setDefaults()
        this.setOptions()

        this._isInitialized.resolve()
    }

    //#endregion


    //#region Parent/Child

    public get isInitialized(): JQueryPromise<void> {
        return this._isInitialized.promise()
    }

    public getTabItem(): TabItem {
        return {
            active: this.isActive,
            index: this.index,
            name: this.name,
            text: this.text,
            visible: this.isVisible,
        }
    }

    public setActive(): void {
        this.isActive = true;
        this.$element.css('display', 'block')
        this.$element.css('height', '100%')
    }

    public setInactive(): void {
        this.isActive = false;
        this.$element.css('height', 'auto')
        this.$element.css('display', 'none')
    }

    private registerWithParent(): void {
        this.parentController.registerTab(this)
        this.index = this.parentController.getNextTabIndex()

        if (this.name == null) {
            this.name = `tabItem${this.index}`
        }
    }

    //#endregion


    //#region Options

    private setDefaults(): void {
        this.isActive = false
        this.isVisible = true
        this.name = null
        this.text = null
    }

    private setOptions(): void {
        if (this.options != null) {
            if (this.options.name != null) {
                this.name = this.options.name
            }

            if (this.options.text != null) {
                this.text = this.options.text
            }

            if (this.options.visible != null) {
                this.isVisible = this.options.visible
            }
        }
    }

    //#endregion
}
